import { Icon, VStack } from '@hover/blueprint';
import { iCheckCircle } from '@hover/icons';
import React from 'react';
import { useLocation } from 'react-router';

import { Alert } from 'src/shared/components';
import {
  CanonicalLink as MetaCanonicalLink,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { useEphemeralEmail, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { TwoColumn } from 'src/shared/layouts';
import { Route } from 'src/shared/route';

import { Form } from './Form';

const Download = () => {
  const t = useTranslate(TranslationNamespace.SIGN_UP);
  const { pathname } = useLocation();

  // FIXME: use a different piece of state to determine whether
  // to show the account created successfully message
  const { email } = useEphemeralEmail();

  const isSuccessRoute =
    pathname === Route.SIGN_UP_HOMEOWNER_DOWNLOAD_SUCCESS.path;

  const conditionals = isSuccessRoute
    ? {
        heading: t('homeownerDownload.textSent'),
        subheading: t('homeownerDownload.ifYouDidNotRecieveATextLink'),
      }
    : {
        heading: t('homeownerDownload.homeownerDownload'),
        subheading: t('homeownerDownload.textMeDownloadLink'),
      };

  return (
    <VStack>
      <MetaCanonicalLink pathname={Route.SIGN_UP_HOMEOWNER_DOWNLOAD.path} />
      {email && (
        <Alert
          color="success"
          data-testid="account-created-message"
          flexDirection="row"
        >
          {t('accountCreationSuccessful')}
        </Alert>
      )}
      <MetaTitle title={t('homeownerDownload.homeownerDownloadTitle')} />
      {isSuccessRoute && (
        <Icon color="success500" icon={iCheckCircle} size="huge" />
      )}
      <TwoColumn.Header {...conditionals} headingSize={650} maxWidth="21rem" />
      <TwoColumn.Main>
        <Form />
      </TwoColumn.Main>
    </VStack>
  );
};

export { Download };
